import { WebParameterContext, WebResponesContext } from '../../model/common';
import { DatePipe} from '@angular/common';
import { SysAccount } from 'src/model/sys.account';
declare var app;
export class ServicesRowInspection {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        if (webcontext.ConfigType.toLowerCase() == "form") {
            webcontext.ConfigName="TBProductCheckMasterXML";
            let id = null;
           if(localStorage.getItem("IDs")){
            id=localStorage.getItem("IDs");
           }
          
            let dataArrar:Array<any> = webcontext.RequestBody;
            let dataNewArrar:Array<any> = [];
            let imgArray:Array<any> = [];
            let resquestimg:Array<any> = [];
            let mast_ID:any = null;
            if(dataArrar.length<=0){
                webcontext.ResponseMessage.Success = false;
                webcontext.ResponseMessage.ErrorMessage="未检测到分销数据";
            }else{
                let oldimg:Array<any>=[];
                // dataNewArrar = dataArrar;
                //过滤掉上传图片的分类
                dataArrar.forEach((items,indexof)=>{
                    if(items.pic.value.length>0){
                        dataNewArrar.push(items);
                    }

                });
                   if(dataNewArrar.length<=0){//没有上传任何照片
                    webcontext.ResponseMessage.Success = false;
                    webcontext.ResponseMessage.ErrorMessage="请先AR拍照";
                   }else{
                    dataNewArrar.forEach((items,index)=>{
                        if(items.Master_ID.value){//主档ID;
                            mast_ID = items.Master_ID.value;
                        }
                        
                        let obj={};
                            obj["a_FK_TBProductBrand_ID"]=items.ID.value;
                            imgArray.push(items.pic.value);
                            let img:Array<any>=[];
                            items.pic.value.forEach(items=>{
                                if(items.new){
                                    img.push(items.new);
                                    oldimg.push(app.IMAGEREADURL+items.new);
                                }
                            });
                            if(items.TBProductCheck_ID.value){//更新数据
                                obj["a_ID"]=items.TBProductCheck_ID.value;
                            }
                            obj["a_PhotoBefore"]=img.toString();
                            // obj["a_PhotoBefore"]="1016.jpg,1220.jpg";
                            obj["a_FK_SystemUser_ID"]= webcontext.Account.Id;
                            resquestimg.push(obj);
                       
                       });
                       if(oldimg.length>20){//表示文件不能超过20张

                        webcontext.ResponseMessage.Success = false;
                        webcontext.ResponseMessage.ErrorMessage="上传照片不能超过20张";
                       }
                        let requestBody = {};
                        requestBody["a_FK_SystemUser_ID"]=webcontext.Account.Id;//分销人
                         requestBody["a_PhotoAfter"]=oldimg.toString();//返回所有照片信息
                         if(mast_ID){//主档ID存在表示修改
                            webcontext.OpType="edite";//表示修改
                            requestBody["a_ID"]=mast_ID;
                         }
                        //  requestBody["a_PhotoAfter"]="http://webtest.mobizone.cn:9508/uploads/image/sfa/1016.jpg,http://webtest.mobizone.cn:9508/uploads/image/sfa/1220.jpg";//返回所有照片信息
                        if(localStorage.getItem("tbstore")){
                            let stroe = JSON.parse(localStorage.getItem("tbstore"))["ID"];//门店信息ID
                            requestBody["a_FK_TBStore_ID"]=stroe;
                        }
                        let datepie: DatePipe = new DatePipe("en-US");
                        requestBody["a_TaskDate"]=datepie.transform(new Date(), "yyyy-MM-dd");
                        requestBody["CHILDOBJ_TBProductCheckXML"] = {
                            "Datas": resquestimg,
                            "Info": {
                            "FormFKElementModel": "a_FK_TBProductCheckMaster_ID",
                            "ProviderFKElementModel": "a_ID",
                            "FormConfigName": "TBProductCheckXML"
                            }
                        };
                    webcontext.RequestBody = requestBody;

                  }
                       
                //    webcontext.RequestBody =JSON.stringify(webcontext.RequestBody);
                //    console.log(webcontext);
                //    console.log(JSON.stringify(webcontext.RequestBody));
                // if(imgArray.length<=0){
                    // webcontext.ResponseMessage.Success = false;
                    // webcontext.ResponseMessage.ErrorMessage="请先拍照";
                // }
            }
            console.log("分销检测");
            // webcontext.ResponseMessage.Success = false;
            
    }
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
      
        return webContext;
    }
}